import React from 'react';
import FormInput from 'components/Input/FormInput';

interface IDeactivationScheduleInput {
	changeDeactivationSchedule: (value: string) => void;
}

const DeactivationScheduleInput: React.FC<IDeactivationScheduleInput> = ({ changeDeactivationSchedule }) => (
	<FormInput
		testId="DeactivationScheduleInput"
		name="deactivationSchedule"
		label="deactivationScheduleLabel"
		placeholder="cronExpressionInputPlaceholder"
		maxLength={255}
		onChange={changeDeactivationSchedule}
	/>
);

export default React.memo(DeactivationScheduleInput);
